import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IOffset {
  id: string
  offset: number
  bottomScroll: number
}

const initialState: {
  offsets: Record<string, IOffset>
} = {
  offsets: {}
}

interface UpdateProps {
  jid: string
  offset: IOffset
}

const messagesScrollOffset = createSlice({
  name: 'messagesScrollOffset',
  initialState,
  reducers: {
    update(state, {payload}: PayloadAction<UpdateProps>) {
      const  { jid, offset } = payload
      state.offsets[jid] = {
        ...offset
      }
    }
  }
})

export const {
  update
} = messagesScrollOffset.actions
export default messagesScrollOffset.reducer
